import React from "react";
import AyudaTablaRegistros from "./AyudaTablaRegistros";

const SinExpandir = (props) => {
  return <AyudaTablaRegistros expandible={false} {...props} />;
};

export default SinExpandir;